import AutoFormInput from '@shared/components/forms/auto-form/auto-form-input/auto-form-input.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FormFieldConfig } from '@shared/interfaces/config';
// import { set, get } from 'lodash';
import { get } from 'lodash';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';

@Component({
  name: 'bpc-auto-form-group',
  components: {
    'bpc-auto-form-input': AutoFormInput,
    'bpc-switch': Switch,
  },
})
export default class AutoFormGroup extends Vue {
  @Prop(Array) readonly fields: FormFieldConfig[];
  @Prop(Object) readonly value: AnyEntity;
  @Prop(Object) readonly errors: object;
  @Prop(Boolean) readonly disabled: boolean;
  @Prop(String) readonly disableTag: string;
  @Prop(String) readonly permissionEntityName: string;
  @Prop([String, Object]) readonly containerClass: string | object;

  get model(): AnyEntity {
    return this.value;
  }
  set model(val: AnyEntity) {
    this.$emit('input', val);
  }

  getDefaultValueSwitchModel(fieldName: string): boolean {
    return this.model && this.model.defaultValueSwitchModel
      ? !!this.model.defaultValueSwitchModel[fieldName]
      : false;
  }

  initializedDefaultValueSwitchModel: boolean = false;

  mounted() {
    setTimeout(() => {
      this.initilizeDefaultValueSwitchModel();
    }, 100);
  }

  initilizeDefaultValueSwitchModel() {
    this.initializedDefaultValueSwitchModel = false;
    this.fields.forEach(fieldConfig => {
      if (fieldConfig.showDefaultValueSwitch) {
        if (!this.model['defaultValueSwitchModel']) {
          this.$set(this.model, 'defaultValueSwitchModel', {});
        }
        const fieldPath = get(fieldConfig, 'fieldPath', get(fieldConfig, 'name'));
        const formModelValue = get(this.model, fieldPath, null);

        const defaultValueSwitchModelValue =
          fieldConfig.showDefaultValueSwitch &&
          (formModelValue == null || formModelValue === fieldConfig.defaultValue);
        this.$set(
          this.model['defaultValueSwitchModel'],
          fieldConfig.name,
          defaultValueSwitchModelValue || false,
        );
      }
    });

    this.initializedDefaultValueSwitchModel = true;
  }

  emitFieldChangeRecursive(field, value) {
    this.$emit('field-change', field, value);
  }

  emitDeleteMediaFile($event) {
    this.$emit('delete-media-file', $event);
  }
  emitInputCustomEvent($event) {
    this.$emit('input-custom-event', $event);
  }

  checkConditionalDisabled(field: FormFieldConfig) {
    if (field.conditionalDisabled) {
      const operator = get(field, 'conditionalDisabled.operator', '=');
      if (operator) {
        return this.compare(
          operator,
          this.value[field.conditionalDisabled.fieldPath],
          field.conditionalDisabled.value,
        );
      } else {
        return this.value[field.conditionalDisabled.fieldPath] === field.conditionalDisabled.value;
      }
    }
  }

  checkPermissionsToDisabled() {
    const entity = this.permissionEntityName?.replace('-', '_');
    return (
      this.permissionEntityName &&
      !this.$authorizationService.hasPermissions([`manage_${entity}`, `manage_own_${entity}`])
    );
  }

  compare(operator, currentValue, targetValue) {
    switch (operator) {
      case '=':
        return currentValue == targetValue;
      case '!=':
        return currentValue != targetValue;
      case '>':
        return currentValue > targetValue;
      case '<':
        return currentValue < targetValue;
      case '>=':
        return currentValue >= targetValue;
      case '<=':
        return currentValue <= targetValue;
      case 'in':
        return targetValue.indexOf(currentValue) > -1;
      default:
        return false;
    }
  }
}
